/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ChangeEvent, KeyboardEvent, FocusEvent, MouseEvent, ReactText, useState, useEffect } from 'react'

export interface UseMoneyMaskParams {
  prefix?: string
  suffix?: string
  thousandsSeparatorSymbol?: string
  allowDecimal?: boolean
  decimalSymbol?: string
  decimalLimit?: number
  integerLimit?: number
  allowLeadingZeroes?: boolean
  /**
   * onChange всегда возвращает строку
   */
  alwaysReturnString?: boolean
  onChange?: (val?: string | number, e?: ChangeEvent<HTMLInputElement>) => void
  onClick?: (e: MouseEvent<HTMLInputElement>) => void
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
  onKeyUp?: (e: KeyboardEvent<HTMLInputElement>) => void
  value?: ReactText
  placeholder?: string
  inputMode?: 'text' | 'numeric' | 'decimal'
}

export const useMoneyMask = (params: UseMoneyMaskParams) => {
  const {
    suffix = '',
    thousandsSeparatorSymbol = '',
    allowDecimal = false,
    allowLeadingZeroes,
    decimalLimit,
    integerLimit,
    placeholder,
    onClick,
    onFocus,
    onBlur,
    onChange,
    onKeyUp,
    value,
    inputMode,
  } = params

  const mask = [
    { mask: '' },
    {
      mask: `num${suffix}`,
      lazy: false,
      blocks: {
        num: {
          mask: Number,
          scale: allowDecimal ? decimalLimit : 0,
          radix: '.',
          mapToRadix: [',', '.'],
          lazy: false,
          thousandsSeparator: thousandsSeparatorSymbol,
          normalizeZeros: true,
          max: integerLimit ? 10 ** integerLimit - 1 : undefined,
          min: allowLeadingZeroes ? undefined : 0,
        },
      },
    },
  ]

  const setCaret = (e: MouseEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement

    if ((input.selectionStart ?? 0) > input.value.length - 2) {
      input.setSelectionRange(input.value.length - 2, input.value.length - 2)
    }
  }

  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    setCaret(e)
    onClick && onClick(e)
  }

  const [inputPlaceholder, setInputPlaceholder] = useState(placeholder)

  useEffect(() => {
    setInputPlaceholder(placeholder)
  }, [placeholder])

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    setInputPlaceholder(suffix)
    onFocus && onFocus(e)
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setInputPlaceholder(placeholder)
    onBlur && onBlur(e)
  }

  const handleChange = (val: string, mask: any) => {
    if (!onChange) {
      return
    }
    onChange && onChange(mask.unmaskedValue)
  }

  return {
    phoneMask: mask,
    value: !value ? '' : value,
    placeholder: inputPlaceholder,
    inputMode: inputMode || ('decimal' as const),
    onClick: handleClick,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChangeMasked: handleChange,
    onKeyUp,
  }
}
